import { Spin } from 'antd';
import React, { Suspense, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Navigate, Route, useNavigate, Routes } from 'react-router-dom';
import { Ajax } from './components/Ajax';
import Layout from './components/Layout';
import { menuItems } from './components/Navigation/NavigationMenu';
import { Administrator } from './pages/Administrator';
import AdministratorDetails from './pages/Administrator/detail';
import Login from './pages/Login';
import LoginRedirect from './pages/LoginRedirect';
import Logout from './pages/Logout';
import Product from './pages/Products';
import SalesNetwork from './pages/SalesNetworks';
import SalesNetworkDetails from './pages/SalesNetworks/detail';
import Statistics from './pages/Statistics';
import ProductDetails from './pages/Products/detail';
import ProductSalesNetwork from './pages/ProductSalesNetworks';
import ProductSalesNetworkDetails from './pages/ProductSalesNetworks/detail';
import Tarif from './pages/Tarif';
import TarifDetails from './pages/Tarif/detail';
import Translations from './pages/Translations';
import UITranslations from './pages/UITranslations';
import UITranslationDetails from './pages/UITranslations/detail';
import Faq from './pages/Faq';
import FaqDetails from './pages/Faq/detail';
import VersionDetails from './pages/Version/detail';
import Version from './pages/Version';
import i18n from './Shared/Translation/i18n';
import { Template, Template2 } from './pages/Template';
import { ApiUrl, AppPages, StoreKeys, UserRoles } from './project/Defines';
import { Project } from './project/Project';
import { changeNetwork, setNetworks, storageChange } from './store/actions';
import LogoutRedirect from './pages/LogoutRedirect';
import AquamedSalesNetworksConfig from './pages/SalesNetworkConfig/Aquamed';
import ThercodimSalesNetworksConfig from './pages/SalesNetworkConfig/Thercodim';
import TabStripRouter from './Shared/TabStripRouter';
import Thercodim from './pages/Faq/Thercodim';
import ThercodimVersion from './pages/Version/Thercodim';
import Information from './pages/Information';
// import Version from './pages/Version';

const routings = [
    { page: AppPages.Login, component: Login },
    { page: AppPages.Logout, component: Logout },
    { page: AppPages.Template, component: Template },
    { page: AppPages.Administrator, component: Administrator },
    { page: AppPages.AdministratorDetails, component: AdministratorDetails, routeParams: ':id' },
    { page: AppPages.ProductDetails, component: ProductDetails, routeParams: [':type', ':id'] },
    { page: AppPages.Product, component: Product, routeParams: ':type' },
    { page: AppPages.ProductSalesNetworkDetails, component: ProductSalesNetworkDetails, routeParams: [':type', ':id'] },
    { page: AppPages.ProductSalesNetwork, component: ProductSalesNetwork, routeParams: ':type' },

    { page: AppPages.SalesNetworkDetails, component: SalesNetworkDetails, routeParams: [':id'] },
    { page: AppPages.SalesNetwork, component: SalesNetwork },
    {
        page: AppPages.Statistics, component: TabStripRouter, index: AppPages.Aquamed,
        subTabs: [{ page: AppPages.Aquamed, component: Statistics, text: i18n('text.aquamede'), index: true },
        { page: AppPages.Thercodim, component: Statistics, text: i18n('text.thercodim'), }]
    },

    {
        page: AppPages.SalesNetworkConfig, component: TabStripRouter, index: AppPages.Aquamed,
        subTabs: [{ page: AppPages.Aquamed, component: AquamedSalesNetworksConfig, text: i18n('text.aquamede'), index: true },
        { page: AppPages.Thercodim, component: ThercodimSalesNetworksConfig, text: i18n('text.thercodim'), }]
    },

    { page: AppPages.TarifDetails, component: TarifDetails, routeParams: [':id'] },
    { page: AppPages.Tarif, component: Tarif },

    { page: AppPages.Translations, component: Translations },

    { page: AppPages.UITranslationDetails, component: UITranslationDetails, routeParams: [':id'] },
    { page: AppPages.UITranslations, component: UITranslations },

    { page: AppPages.FaqDetails, component: FaqDetails, routeParams: [':id'] },
    {
        page: AppPages.Faq, component: TabStripRouter, index: AppPages.Aquamed,
        subTabs: [{ page: AppPages.Aquamed, component: Faq, text: i18n('text.aquamede'), index: true },
        { page: AppPages.Thercodim, component: Thercodim, text: i18n('text.thercodim'), }]
    },

    { page: AppPages.VersionDetails, component: VersionDetails, routeParams: [':id'] },
    {
        page: AppPages.Version, component: TabStripRouter, index: AppPages.Aquamed,
        subTabs: [{ page: AppPages.Aquamed, component: Version, text: i18n('text.aquamede'), index: true },
        { page: AppPages.Thercodim, component: ThercodimVersion, text: i18n('text.thercodim') }]
    },

    { page: AppPages.Information, component: Information },
];

/**
*  the Base component that also manages routing
 * @module App
 */
function App(props) {
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [networkProjectTypes, setNetworkProjectTypes] = useState({});
    //const history = useHistory();
    const navigate = useNavigate();
    const { role, isLoggedIn, storageChange, /*setNetworks,*/ networks, changeNetwork, network } = props;// NOSONAR
    const loading = <div style={{ "margin": "25% auto" }}><Spin size="large" /></div>;
    let subItem;

    const homeRedirectItem = menuItems.find(i => (i.to && Project.hasRoleAccess(role, i.to))
        || (i.subMenu && i.subMenu.some(sub_item => {
            const hasAccess = Project.hasRoleAccess(role, sub_item.to);
            if (hasAccess) {
                subItem = sub_item;
            }
            return hasAccess;
        }))
    );

    const homeRedirect = subItem ? Project.getPageUrl(subItem.to, subItem.routeParams) : Project.getPageUrl(homeRedirectItem ? homeRedirectItem.to : '');// NOSONAR
    const [showPages, setShowPages] = useState(false);
    useEffect(() => {
        setIsFirstLoad(false);
        const handler = e => {
            const trackingKeys = [StoreKeys.UserToken, StoreKeys.UserName, StoreKeys.LoggedIn, StoreKeys.ListStates, StoreKeys.Culture, StoreKeys.Role, StoreKeys.Network, StoreKeys.ExpireTime];
            if (trackingKeys.includes(e.key)) {
                storageChange();
            }
        };

        setTimeout(() => {
            if (isLoggedIn) {
                Ajax.post({
                    url: ApiUrl.Check,
                    data: {},
                    success: function (response) {
                        if (response) {
                            setShowPages(true);
                        }
                    }
                })
            } else {
                setShowPages(true);
            }
        }, 100);

        window.addEventListener('storage', handler);
        return () => { window.removeEventListener('storage', handler) }
    }, []);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (isLoggedIn && role === UserRoles.ADMIN && network) {
            const n = networks.find((e) => e.value === network);
            if (n) {
                setNetworkProjectTypes({
                    thercodim: n.thercodim,
                    aquamed: n.aquamede
                });
            }
        }
    }, [role, network]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!isFirstLoad && role) {
            //history.push(Project.getPageUrl(AppPages.Home));
            navigate(`${Project.getPageUrl(AppPages.Home)}`);
        }
    }, [role]);// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (!isFirstLoad) {
            if (networks && networks.length) {
                if (!networks.find(n => n.value === network)) {
                    changeNetwork(networks[0].value);
                }
            } else if (network) {
                changeNetwork(null);
            }
        }
    }, [networks]);// eslint-disable-line react-hooks/exhaustive-deps

    if (!isLoggedIn) {
        return <Suspense fallback={loading}>
            <Layout>
                <Routes>
                    <Route
                        path="/loginredirect/:code"
                        element={<LoginRedirect />}
                    />
                    <Route
                        path="/login"
                        element={<Login />}
                    />
                    <Route
                        path="/logout"
                        element={<Logout />}
                    />
                    <Route
                        path='/template'
                        element={<Template />}
                    />
                    <Route
                        path='/templatedetails'
                        element={<Template2 />}
                    />
                    <Route
                        path="*"
                        element={<Navigate replace={true} to={Project.getPageUrl(AppPages.Login, "", { redirectUrl: window.location.pathname })} />}>
                    </Route>
                </Routes>
            </Layout>
        </Suspense>
    }

    if (!showPages)
        return <>{loading}</>;

    return <Suspense fallback={loading}>
        <Layout>
            <Routes>
                <Route
                    exact
                    path='/'
                    element={(homeRedirect && <Navigate to={homeRedirect} />) || (<Navigate to={Project.getPageUrl(AppPages.Login)} />)}
                >
                </Route>
                <Route
                    path="/logoutredirect"
                    element={<LogoutRedirect />}
                />

                <Route
                    path="/login"
                    element={(homeRedirect && <Navigate to={homeRedirect} />) || (<Navigate to={Project.getPageUrl(AppPages.Login)} />)}
                >
                </Route>
                {routings.filter(r => {
                    return r.pages ? r.pages.some(p => Project.hasRoleAccess(role, p)) : Project.hasRoleAccess(role, r.page)
                })
                    .map(r => {
                        let El = r.component;

                        if (r.subTabs && r.subTabs.length > 0) {
                            let subTabs = []
                            if (Object.keys(networkProjectTypes).length !== 0 && r.page !== AppPages.Version) {
                                subTabs = r.subTabs.filter(subTab => networkProjectTypes[subTab.page] === true)
                            }

                            let index = subTabs.length === 1 ? subTabs[0].page : null

                            return <Route key={r.page} path={Project.getPageUrl(r.page)} element={<El state={{ r, networkProjectTypes, role }} />}>
                                <Route index element={<Navigate to={index || r.index} />} />
                                {r.subTabs.map(subTab => {
                                    const SubTabComponent = subTab.component;
                                    const isFirstSubTab = subTabs.length && subTabs[0].page === subTab.page;

                                    return (
                                        <React.Fragment key={subTab.page}>
                                            {subTabs.length ? (
                                                isFirstSubTab ? (
                                                    <Route index path={subTab.page} element={<SubTabComponent />} />
                                                ) : (
                                                    <Route path={subTab.page} element={<SubTabComponent />} />
                                                )
                                            ) : (
                                                subTab.index ? (
                                                    <Route index path={r.index} element={<SubTabComponent />} />
                                                ) : (
                                                    <Route path={subTab.page} element={<SubTabComponent />} />
                                                )
                                            )}
                                        </React.Fragment>
                                    );
                                })}
                            </Route>
                        } else {
                            return <Route
                                key={r.pages ? r.pages.join() : r.page}
                                path={r.pages ? r.pages.map(p => Project.getPageUrl(p.page || p, p.routeParams)) : Project.getPageUrl(r.page, r.routeParams)}
                                //component={r.component}
                                element={<El />}
                            />
                        }
                    }
                    )}
                <Route path="*"
                    //component={NotFound}
                    element={<Navigate to='/' />}
                >
                </Route>

            </Routes>
        </Layout>
    </Suspense>;
}

export default connect(state => ({ isLoggedIn: state.isLoggedIn, role: state.role, network: state.network, networks: state.networks }),
    dispatch => ({
        storageChange: (key) => dispatch(storageChange()),
        setNetworks: (networks) => dispatch(setNetworks(networks)),
        changeNetwork: (network) => dispatch(changeNetwork(network))
    }))(App);
